/**
 * @description
 */

import './sectionCheckboxResultList.scss';

import React from 'react';
import { ISectionOptionResultInfo } from '@umu/umu-types';
import FormRadioboxResultList from '../@formRadioboxResultList/formRadioboxResultList';
import SectionRadioboxResultList from '../@sectionRadioboxResultList/sectionRadioboxResultList';

export default class SectionCheckboxResultList extends SectionRadioboxResultList {
    public render() {
        return super.render();
    }

    public renderFormResult() {
        const { resultList } = this.props.sectionInfo;
        return <FormRadioboxResultList resultList={resultList as ISectionOptionResultInfo[]} />;
    }
}
